import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import PricingProfileName from "../../components/pricingProfile/PricingProfileDetail/PricingProfileName.tsx";
import {useLocationFormState} from "../../components/pricingProfile/PricingProfileForm/PricingProfileUpdateForm";
import PricingProfileUpdateFormProvider from "../../components/pricingProfile/PricingProfileForm/PricingProfileUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const PricingProfileUpdateEditPage = () => {
    
    useTitle(t`Update Pricing Profile`);

    const { pricingProfileId: id } = useParams();
    
    return (
        <Box data-testid="PricingProfile-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="PricingProfile-update-title"
                    >
                        <Trans>Edit Pricing Profile</Trans>:  <PricingProfileName id={id}/>
                    </Typography>
                    <PricingProfileUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default PricingProfileUpdateEditPage;
